import type { VoidFunctionComponent } from 'react';

import Subnav from '../../generic/Subnav';
import SubnavCountBadge from '../../generic/Subnav/SubnavCountBadge';

import type { InventoryDependencyCounts, InventoryDependencyIsLoading } from './types';

type InventorySubnavDropdownProps = {
  baseUrl: string;
  /**
   * Query string (with the leading "?") added to the links for the dependency views.
   */
  dependenciesQuery?: string;
  isLoading: InventoryDependencyIsLoading;
  counts: InventoryDependencyCounts;
  shouldShowBinaryAnalysis: boolean;
  shouldShowSnippets: boolean;
  shouldShowVendored: boolean;
};

const InventorySubnavDropdown: VoidFunctionComponent<InventorySubnavDropdownProps> = ({
  baseUrl,
  dependenciesQuery = '',
  isLoading,
  counts,
  shouldShowBinaryAnalysis,
  shouldShowSnippets,
  shouldShowVendored,
}) => (
  <Subnav.Dropdown to={`${baseUrl}/browse/dependencies${dependenciesQuery}`} navKey="inventory">
    <Subnav.Dropdown.RootItem>
      Inventory
      <SubnavCountBadge
        count={counts.total}
        isLoading={isLoading.any}
      />
    </Subnav.Dropdown.RootItem>
    <Subnav.Dropdown.Item to={`${baseUrl}/browse/dependencies${dependenciesQuery}`} navKey="browse/dependencies">
      Dependencies
      <SubnavCountBadge count={counts.managed || 0} isLoading={isLoading.managed} />
    </Subnav.Dropdown.Item>
    {/* Snippets are only available for project scope */}
    {shouldShowSnippets && (
      <Subnav.Dropdown.Item to={`${baseUrl}/browse/snippets`} navKey="snippets">
        Snippets
        <SubnavCountBadge count={counts.snippets || 0} isLoading={isLoading.snippets} />
      </Subnav.Dropdown.Item>
    )}
    {shouldShowBinaryAnalysis && (
      <Subnav.Dropdown.Item to={`${baseUrl}/browse/binary`} navKey="binary">
        Binary Analysis
        <SubnavCountBadge count={counts.binary || 0} isLoading={isLoading.binary} />
      </Subnav.Dropdown.Item>
    )}
    {shouldShowVendored && (
      <Subnav.Dropdown.Item to={`${baseUrl}/browse/vendored${dependenciesQuery}`} navKey="vendored">
        Vendored
        <SubnavCountBadge count={counts.vendored || 0} isLoading={isLoading.vendored} />
      </Subnav.Dropdown.Item>
    )}
  </Subnav.Dropdown>
);

export default InventorySubnavDropdown;
